import { Shield, Lock, Database, Smartphone } from 'lucide-react';

const AnonymityInfographic = ({ type }) => {
  if (type === 'submission') {
    return (
      <div className="bg-white dark:bg-gray-800 p-6 md:p-8 rounded-xl shadow-lg border dark:border-gray-700">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
          How Report Submission Works
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 py-6">
          <div className="text-center">
            <div className="bg-blue-100 dark:bg-blue-900/30 p-6 rounded-full inline-block mb-3">
              <Smartphone className="w-12 h-12 text-blue-600 dark:text-blue-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">1. You Submit</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              Your report is sent anonymously with no identifying information
            </p>
          </div>
          
          <div className="hidden md:block text-4xl text-gray-300 dark:text-gray-600">→</div>
          
          <div className="text-center">
            <div className="bg-green-100 dark:bg-green-900/30 p-6 rounded-full inline-block mb-3">
              <Database className="w-12 h-12 text-green-600 dark:text-green-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">2. We Store</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              Report saved with a unique ID, but no link to your identity
            </p>
          </div>
          
          <div className="hidden md:block text-4xl text-gray-300 dark:text-gray-600">→</div>
          
          <div className="text-center">
            <div className="bg-purple-100 dark:bg-purple-900/30 p-6 rounded-full inline-block mb-3">
              <Lock className="w-12 h-12 text-purple-600 dark:text-purple-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">3. Key Stored Locally</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              A secret key is saved on your device for future deletion
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'deletion') {
    return (
      <div className="bg-white dark:bg-gray-800 p-6 md:p-8 rounded-xl shadow-lg border dark:border-gray-700">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
          How Report Deletion Works
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 py-6">
          <div className="text-center">
            <div className="bg-orange-100 dark:bg-orange-900/30 p-6 rounded-full inline-block mb-3">
              <Smartphone className="w-12 h-12 text-orange-600 dark:text-orange-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">1. You Request Deletion</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              From the same device, you click delete on your report
            </p>
          </div>
          
          <div className="hidden md:block text-4xl text-gray-300 dark:text-gray-600">→</div>
          
          <div className="text-center">
            <div className="bg-blue-100 dark:bg-blue-900/30 p-6 rounded-full inline-block mb-3">
              <Lock className="w-12 h-12 text-blue-600 dark:text-blue-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">2. Secret Key Sent</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              Your local secret key is sent to prove ownership
            </p>
          </div>
          
          <div className="hidden md:block text-4xl text-gray-300 dark:text-gray-600">→</div>
          
          <div className="text-center">
            <div className="bg-red-100 dark:bg-red-900/30 p-6 rounded-full inline-block mb-3">
              <Database className="w-12 h-12 text-red-600 dark:text-red-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">3. Report Removed</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
              We verify the key and delete the report—still no idea who you are
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default AnonymityInfographic;
